import React, { useState, useEffect } from "react";
import "../all css/interestedsection.css";

import CustDialogBox from "../../components/custom dialogbox/CustDialogBox";
import Interested from "./dialog box/Intereseted";
import AlertCustDialogBox from "../../components/alertbox/AlertCustDialogBox";
import Alertbox from "../../components/alertbox/Alertbox";
const lady_img = require("../../assets/lady_testimonial_textt.svg");

function InterestedSection(props) {
  const [alertToggleModal, setAlertToggleModal] = useState(false);

  const [toggleModal, setToggleModal] = useState(false);

  useEffect(() => {
    if (props.toggleDialog) {
      setToggleModal(props.toggleDialog);
    }
  }, [props.toggleDialog]);

  function handleInterested() {
    setToggleModal(true);
  }

  function handleInterestedDialog(toggleValue) {
    console.log(toggleValue, "line interested");

    setToggleModal(toggleValue);
    setAlertToggleModal(true);
    setTimeout(() => {
      setAlertToggleModal(false);
    }, 2000);
  }

  return (
    <section className="intersted_section_main">
      <div className="intestered_section_under_container">
        <div className="intestered_flex_container">
          <div className="all_content_intetrested_contianer">
            <p
              className="title_text  wow pulse animated"
              data-wow-delay="500ms"
              data-wow-iteration="infinite"
              data-wow-duration="1s"
            >
              Broaden your horizons with DWEC{" "}
            </p>
            <p className="intested_subtitle_text"></p>
            <p className="intested_extra_text">
              We help students identify the course and university that best
              match their aptitude, interest, academic and financial background.
              Our expert team of councillors backed with years of experience,
              strive to provide you with a worry-free overseas education.
            </p>

            <div className="btn_interested_align_container">
              <button className="btn_interested" onClick={handleInterested}>
                Click me
              </button>
            </div>
          </div>
          <div className="photo_intestered_container">
            <div className="lady_dwec_under_contianer">
              <div className="photo_contianer">
                <img
                  src={lady_img.default}
                  alt="dwec_lady"
                  className="photo_lady_self"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustDialogBox
        dialogHeaderName="Let's start a conversation"
        open={toggleModal}
        onClose={() => {
          setToggleModal(false);
        }}
      >
        <Interested
          toggleDialog={toggleModal}
          handleInterestedDialog={handleInterestedDialog}
        />
      </CustDialogBox>

      <AlertCustDialogBox
        dialogHeaderName=""
        open={alertToggleModal}
        onClose={() => {
          setAlertToggleModal(false);
        }}
      >
        <Alertbox />
      </AlertCustDialogBox>
    </section>
  );
}

export default InterestedSection;
